import { EntityHistoryTimelineEntryDto, EntityHistoryEventGroup } from './entity-history-timeline.types';

/**
 * Groups entity history entries by correlationId.
 * Events without a correlationId get their own single-event group.
 * Within each group: events preserve the order from the API response.
 * Groups ordered by the timestamp of their first event, descending (most recent on top).
 */
export function groupEntriesByCorrelation(entries: EntityHistoryTimelineEntryDto[]): EntityHistoryEventGroup[] {
  const groupMap = new Map<string, EntityHistoryTimelineEntryDto[]>();
  let syntheticIndex = 0;

  for (const entry of entries) {
    const key = entry.correlationId ?? `__ungrouped_${syntheticIndex++}`;

    const existing = groupMap.get(key);
    if (existing) {
      existing.push(entry);
    } else {
      groupMap.set(key, [entry]);
    }
  }

  const groups: EntityHistoryEventGroup[] = [];

  for (const [correlationId, events] of groupMap) {
    const firstEvent = events[0];

    groups.push({
      correlationId,
      operation: firstEvent.operation,
      actor: firstEvent.actor,
      events,
      timestamp: firstEvent.timestamp
    });
  }

  groups.sort((a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime());

  return groups;
}

/**
 * Deduplicates entries by id, keeping the first occurrence.
 */
export function deduplicateEntries(entries: EntityHistoryTimelineEntryDto[]): EntityHistoryTimelineEntryDto[] {
  const seen = new Set<string>();
  return entries.filter((entry) => {
    if (seen.has(entry.id)) return false;
    seen.add(entry.id);
    return true;
  });
}
